export default __webpack_public_path__ + "static/media/rona_perry.820bdae4.png";